import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { ImageuploadService } from 'src/app/services/imageupload.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DomSanitizer } from '@angular/platform-browser';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';



@Component({
  selector: 'app-add-training-kl',
  templateUrl: './add-training-kl.component.html',
  styleUrl: './add-training-kl.component.scss',
  providers: [MessageService]
})
export class AddTrainingKlComponent implements OnInit, OnChanges {

  @Input() courseId: any
  @Input() ou : any = null
  @Input() requestData : any
  @Output() submitSucces : EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('fileName', { static: false }) fileNameInput!: ElementRef;


  staticURL = GlobalConstants.staticFilesURL;
  apilink = GlobalConstants.apiURL;

  trainingDetails: any
  material: any[] = []
  klData: any
  data: any
  fileProgress!: boolean;
  uploadProgress!: number;
  fileUpload!: boolean;
  showPDF!: boolean;
  selected: any;
  player: any;
  idView: any;
  editName!: boolean;
  nameUpdate = ''
  rejectModal : boolean = false
  reason : string = ''
  editData : boolean = true

  constructor(
    private dataService: DataService,
    private imageUploadService: ImageuploadService,private domSenitizer: DomSanitizer,
    private messageService: MessageService
    ) { }

  ngOnInit() {
    if (this.requestData) {
      this.klData = this.requestData.data
      this.material = cloneDeep(this.requestData.data.link)
      if(this.requestData.status != 'PENDING'){
        this.editData = false
      }
      this.material?.length ? this. select(this.material[0],0) : '';
    }
    else {
      this.openCourse().then(() => this.createMaterial());
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.requestData) {
      this.klData = this.requestData.data
      this.material = cloneDeep(this.requestData.data.link)
      if(this.requestData.status != 'PENDING'){
        this.editData = false
      }
      this.material?.length ? this. select(this.material[0],0) : '';
    } else {
      this.openCourse().then(() => this.createMaterial());
    }
  }

  

  createMaterial() {
    console.log("====> FIew function 2")
    this.material = []

    this.klData = {
      name: this.data?.title,
      description: this.data?.description,
      image: this.data?.image,
      categoryname: 'Training',
      categoryicon: 'pi pi-th-large',
      ou: this.ou ? this.ou : null,
      announceNotification: true,
    }
    this.data.courseMaterial?.map((item: any) => {
      this.material.push({ link: item.url, name: item.title })
    })
    this.data.session?.map((item: any) => {
      if (!!item.history) {
        this.material.push({ link: item?.history?.history, name: item?.title })
      }
      if (!!item?.video_url) {
        this.material.push({ link: item?.video_url, name: item?.title })
      }
    })
    this.material = this.material;
    this.material?.length ? this. select(this.material[0],0) : '';

  }

  showPdf() {
    this.showPDF = true;
    return this.domSenitizer.bypassSecurityTrustResourceUrl(GlobalConstants.staticFilesURL + this.selected?.link)
  }
  select(item:any,index:number){
    this.selected = item;
    this.selected.index = index;
    item?.link && item?.link?.includes('www.youtube.com') ? this.readyYoutubeView(item) : '';
    this.nameUpdate = '';
  }

  readyYoutubeView(item: any) {
    if (item.link && item.link?.includes('www.youtube.com')) {
      const videoIdMatch = item.link.match(/[?&]v=([^&]+)/);
      this.idView = videoIdMatch ? videoIdMatch[1] : null;
    }
  }

  moveUp(index: number): void {
    if (index > 0) {
      const temp = this.material[index];
      this.material[index] = this.material[index - 1];
      this.material[index - 1] = temp;
    }
  }

  moveDown(index: number): void {
    if (index < this.material.length - 1) {
      const temp = this.material[index];
      this.material[index] = this.material[index + 1];
      this.material[index + 1] = temp;
    }
  }

  edit(name:string){
    if(name){
    this.selected.name = name;
    this.nameUpdate = name;
    this.material = this.material.map((item, index) => {
      this.nameUpdate = '';
      if (item?.name != name && item?.name + item?.link+index === this.selected?.name + this.selected?.link+this.selected?.index) {
        
        return { ...item, ...this.selected };
      }
      return item;
    });
    }
    else{
      this.nameUpdate = this.selected.name;
    }
    this.editName = !this.editName;
  }
  savePlayer(player: any) {
    this.player = player;
  }

  playVideo() {
    this.player.playVideo();
  }

  deleteResource(i: number) {
    if (i >= 0 && i < this.material.length) {
      this.material.splice(i, 1);
    }
  }

  async submit(){
    try {
      if(!this.klData.name || this.klData.name == ''){
        this.messageService.add({ severity: 'error', summary: this.translate('error'),  detail: this.translate('KL name required') });
        return
      }

      this.klData.link = this.material

      let data : any = {
        title : this.klData.name,
        data : this.klData,
        approvedBy : localStorage.getItem('uid')
      }

      const res = await this.dataService.postData('kl-log', data);
      if(res.error){
        this.messageService.add({ severity: 'error', summary: this.translate('error'),  detail: this.translate('KL Request Not Send') });
       return
      }

      this.messageService.add({ severity: 'success', summary: this.translate('success'),  detail: this.translate('KL Request Send Successfully') });


      this.submitSucces.emit(true)
    } catch (error) {
      console.log(error)
    }
  }

  async openCourse() {
    try {
      let res = await this.dataService.getData('course/' + this.courseId);
      if (res.error) {
        return
      }
      this.data = res.data[0]
    } catch (error) {
      console.log(error);
    }
  }


  async addFiles(event: any, name: string) {
    const file: File = event.target.files[0];
    let obj: any = {};
    obj['file'] = {
      file: file,
      type: 'data'
    };
    console.log(obj);
    this.handleFileUpload(obj, name, 'file');
  }


  handleFileUpload(file: any, fileName: string, eventType: string): string | null {
    this.fileProgress = true;
    this.fileUpload = false;
    this.imageUploadService.uploadImageWithProgress(file.file.file, file.file.type).subscribe({
      next: (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            this.uploadProgress = Math.round(event.loaded / event.total! * 100);
            console.log(`Uploaded! ${this.uploadProgress}%`);
            break;
          case HttpEventType.Response:
            if (event.ok) {
              setTimeout(() => {
                this.uploadProgress = 0;
              }, 1500);
              switch (eventType) {
                case 'file':
                  this.material.push({
                    link: event.body.data,
                    name: fileName ? fileName : 'N/A'
                  });
                  this.fileUpload = true;
                  this.fileNameInput.nativeElement.value = '';
                  
                  break;

                case 'update_file':
                 //for files update case
                  break;
              }
            } else {
              // error
            }
        }
      },
      error: (error) => {
        this.fileProgress = false;
        this.uploadProgress = 0;

      },
      complete: () => {
        this.fileProgress = false;
        this.uploadProgress = 0;
      }
    })
    return ""
  }

  nameChange(name:string) {
    if (this.fileUpload) this.material[this.material?.length - 1].name = name;
    this.material
  }


  async approveKL(){
    try {

      if(!this.klData.name || this.klData.name ==''){
        this.messageService.add({ severity: 'error', summary: this.translate('error'),  detail: this.translate('KL name required') });
        return
      }

      if(!this.klData.image || this.klData.image == ''){
        this.messageService.add({ severity: 'error', summary: this.translate('error'),  detail: this.translate('Please Upload image for library') });
        return
      }


      this.klData.link = this.material
      const res = await this.dataService.postData('knowledge-library', this.klData);
      if(res.error){
        this.messageService.add({ severity: 'error', summary: this.translate('success'),  detail: this.translate('KL not created') });
      }
      let data  = {
        _id : this.requestData._id,
        status : 'APPROVED',
        approvedBy : localStorage.getItem('uid')
      }
      await this.updateLog(data)
      this.messageService.add({ severity: 'success', summary: this.translate('success'),  detail: this.translate('KL Approved') });
      this.submitSucces.emit(true)
    } catch (error) {
      console.log(error)
    }
  }


  rejectRequest = async () => {
    try {
      if(this.reason == '' || !this.reason){
        this.messageService.add({ severity: 'error', summary: this.translate('error'),  detail: this.translate('Please state a reason to submit') });
        return
      }
      let data : any = {
        _id : this.requestData._id,
        reason : this.reason,
        status : 'REJECTED',
        approvedBy : localStorage.getItem('uid')
      }
      await this.updateLog(data)
      this.submitSucces.emit(true)
    } catch (error) {
        console.log(error)
    }
  }


  updateLog = async (data: any) => {
    try {
      let res = await this.dataService.postData('kl-log', data, 'PUT')
      if (res.error) {
        this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Request to Updated') });
      }
      return
    } catch (error) {
      console.log(error)
    }
  }


  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

}

interface Material {
  link: string
  name: string
}